import React from 'react';
import { KTSVG } from '../../../../../../_start/helpers';
import {
  ContactsOtherInfoWithIconsElement,
  IconAndDescription,
} from './ContactsOtherInfoWithIconsElement';

interface Props {
  idx: number;
  data: ContactsOtherInfoWithIconsElement;
  item: IconAndDescription;
  updateData: (to: Partial<IconAndDescription>, idx: number) => void;
}

export const ContactsOtherInfoWithIconsIcon: React.FC<Props> = ({
  idx,
  data,
  item,
  updateData,
}) => {
  return (
    <>
      <div className="icon__outer">
        <div className="overlay">
          <div className="overlay-layer bg-dark bg-opacity-10">
            <label
              className="px-1 btn btn-sm btn-icon btn-color-primary btn-light-primary"
              data-bs-toggle="modal"
              data-bs-target={`#contacts-other-info-with-icons-${idx}-${data.id}`}
            >
              <KTSVG
                path="/media/icons/duotone/General/Edit.svg"
                className="svg-icon-1"
              />
            </label>
          </div>
          <div>
            {item.icon_url ? (
              <img className="icon" src={item.icon_url} alt="Uploaded" />
            ) : (
              <KTSVG path={item.icon ?? ''} svgClassName="icon" />
            )}
          </div>
        </div>
      </div>
    </>
  );
};
